import React, { useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import zoomIcon from '../../../../images/features/saga/zoom.png';
import ImagesModal from './ImagesModal';
import ImageWithCredit from './ImageWithCredit';
import type { AreaImageProps } from './Area';

type AreaImagesProps = {
  images: Array<AreaImageProps>,
  number: string,
  area: string,
};

const useStyles = makeStyles(() => ({
  imagesContainer: {
    display: 'flex',
  },
  image: {
    width: '100%',
  },
  imageContainer: {
    position: 'relative',
  },
  iconButton: {
    position: 'absolute',
    right: 0,
    bottom: 6,
  },
  zoomIcon: {
    width: 28,
  },
}));

const AreaImages = ({ images = [], number, area }: AreaImagesProps) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <Grid container>
      <Grid item xs={6}>
        <ImageWithCredit {...images[0]} />
      </Grid>
      <Grid item xs={6} className={classes.imageContainer}>
        <img
          src={images[1]?.src}
          alt={images[1]?.title}
          className={classes.image}
        />
        <IconButton className={classes.iconButton} onClick={handleOpen}>
          <img src={zoomIcon} alt="拡大" className={classes.zoomIcon} />
        </IconButton>
        <ImagesModal
          open={open}
          handleClose={handleClose}
          images={images}
          number={number}
          area={area}
        />
      </Grid>
    </Grid>
  );
};

export default AreaImages;
